import { Field, ObjectType } from '@nestjs/graphql'
import { BaseModelWithoutUserDto } from '../base/baseModelWithoutUser.dto'

@ObjectType()
export class BasicUserDto extends BaseModelWithoutUserDto {
  @Field()
  emailAddress!: string

  @Field(t => String, { nullable: true })
  name?: string

  @Field(t => String, { nullable: true })
  image?: string
}
